import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiDelete, operationsClient } from '@/lib/api';
import { timesheetEndpoints } from '@/lib/api/endpoints';
import { timesheetKeys } from '@/lib/queryKeys';

/** Delete a single time entry from the day drill-down. */
export function useDeleteTimesheetEntry() {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, string>({
    mutationFn: (id) => apiDelete(operationsClient, timesheetEndpoints.entryDetail(id)),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: timesheetKeys.all() });
      toast.success('Time entry deleted');
    },
  });
}
